let buttons = document.querySelectorAll('.js-yandex-button');

if (buttons.length) {
    buttons.forEach(function (button) {
        button.addEventListener('click', function (e) {
            let item = e.target
            if (item.tagName == 'IMG') {
                item = item.parentNode
            }
            let id = item.dataset.ymId;
            let action = item.dataset.ymAction;
            if (id && action) {
                ym(id,'reachGoal',action)
            }
        })

    })
}